import { render, staticRenderFns } from "./PriceListDetailForm.vue?vue&type=template&id=448073d1&"
import script from "./PriceListDetailForm.vue?vue&type=script&lang=js&"
export * from "./PriceListDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./PriceListDetailForm.vue?vue&type=style&index=0&id=448073d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports